import React, { useEffect } from 'react';
import { PeekBox, PeekButton, PeekStack, PeekDivider } from '@piiqtechnologies/ui-components';
import { HfovSlider } from './HfovSlider.js';
import 'tslib';
import '../../../../../services/base/baseDiscoverService.js';
import '../../../../../services/base/baseV3Service.js';
import '../../../../../services/base/baseInsightsService.js';
import '../../../../../services/sgtService.js';
import '@analytics/storage-utils';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import { useError } from '../../../../../utils/ErrorProvider.js';
import { useLoader } from '../../../../../utils/LoaderProvider.js';
import '../../../../../utils/RefetchProvider.js';
import '../../../../../utils/NotificationProvider.js';
import { downloadFileFromUrl } from '../../../../../utils/fileUtils.js';
import '../../../../../utils/ContactProvider.js';
import '../../../../../utils/PolicyProvider.js';
import '../../../../../utils/AnalyticsProvider.js';
import '../../../../../types/AccessDevice.js';
import '../../../../../types/Analytics.js';
import '../../../../../types/CASACommunity.js';
import '../../../../../types/Community.js';
import '../../../../../types/DxSettings.js';
import '../../../../../types/MagicButton.js';
import '../../../../../types/Pannellum.js';
import '../../../../../types/Prospect.js';
import '../../../../../types/ProspectIntelligence.js';
import '../../../../../types/Space.js';
import '../../../../../types/Tour.js';
import '../../../../../utils/analyticsPlugin.js';
import '../../../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../../../utils/cookieUtils.js';
import '../../../../../utils/termsConditionsAgreementsUtils.js';
import '../../../../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../../../../services/base/internalApiBaseService.js';
import '../../../../../services/base/casaBaseService.js';
import '../../../../../services/scanRequestsService.js';
import '../../../../../services/db/insightsReportsDB.js';
import '../../../../../services/aiDiscoverability.js';
import 'dot-object';
import '../../../../../apis/analytics/useDownloadAnalyticsReports.js';
import { useGenerate2dImage } from '../../../../../apis/space/useGenerate2dImage.js';
import '../../../../../apis/upload/useSignedURL.js';
import { usePannellumViewer } from '../../../../components/pannellum-viewer/PannellumProvider.js';
import { getNodeById } from '../../../../components/pannellum-viewer/pannellumUtils.js';

const VerticalGridLine = (props) => (React.createElement(PeekDivider, { orientation: "vertical", sx: Object.assign({ width: 0, height: "100%" }, props), light: true, absolute: true, flexItem: true }));
const HorizonatlGridLine = (props) => (React.createElement(PeekDivider, { orientation: "horizontal", sx: Object.assign({ height: 0 }, props), light: true, absolute: true, flexItem: true }));
const ExtractPhotoTools = ({ closeExtractPhotoTool }) => {
    var _a;
    const [generate2DImage, generatedImage, generateImageInProgress, generateImageError] = useGenerate2dImage();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { getHfov, getPitch, getYaw, getConfig, details } = usePannellumViewer();
    const { imageId, nodeId } = getConfig();
    const node = getNodeById(details.nodes, nodeId);
    const isStagedImagedLoaded = ((_a = node === null || node === void 0 ? void 0 : node.stagedPhoto) === null || _a === void 0 ? void 0 : _a._id) === imageId;
    useEffect(() => {
        setLoader(generateImageInProgress);
    }, [generateImageInProgress]);
    useEffect(() => {
        if (generateImageError) {
            setError(generateImageError === null || generateImageError === void 0 ? void 0 : generateImageError.message);
        }
    }, [generateImageError]);
    useEffect(() => {
        if (generatedImage) {
            downloadFileFromUrl(generatedImage, `${getConfig().name}.jpg`);
        }
    }, [generatedImage]);
    const extractImage = () => {
        var _a, _b;
        const imageUrl = (!isStagedImagedLoaded && ((_a = node === null || node === void 0 ? void 0 : node.photo) === null || _a === void 0 ? void 0 : _a.url)) || ((_b = node === null || node === void 0 ? void 0 : node.stagedPhoto) === null || _b === void 0 ? void 0 : _b.url);
        generate2DImage({
            imageURL: imageUrl,
            hfov: getHfov() * 0.7,
            pitch: getPitch(),
            yaw: getYaw(),
        });
    };
    return (React.createElement(PeekBox, null,
        React.createElement(PeekBox, { sx: { position: "absolute", top: "0", left: "0", p: 1.5, zIndex: 1 } },
            React.createElement(PeekButton, { color: "secondary", onClick: closeExtractPhotoTool, variant: "contained", "aria-label": "Back" }, "Back")),
        React.createElement(PeekBox, { sx: { position: "absolute", top: "0", right: "0", height: "80%", p: 3.5, zIndex: 1 } },
            React.createElement(HfovSlider, null)),
        React.createElement(PeekStack, { justifyContent: "center", sx: { position: "absolute", bottom: "0", p: 2, left: "50%", transform: "translate(-50%, -50%)", zIndex: 1 } },
            React.createElement(PeekButton, { onClick: extractImage, variant: "outlined", sx: {
                    width: 63,
                    height: 63,
                    borderRadius: "50%",
                    backgroundColor: "secondary.light",
                    borderColor: "text.secondary",
                    p: 0,
                    " :hover": { backgroundColor: "secondary.light" },
                }, "aria-label": "Extract 2D Image" },
                React.createElement(PeekBox, { sx: {
                        width: 44,
                        height: 44,
                        borderRadius: "50%",
                        backgroundColor: "secondary.main",
                        borderColor: "primary.main",
                        borderStyle: "solid",
                        borderWidth: 0.1,
                    } }))),
        React.createElement(HorizonatlGridLine, { top: "33.3%" }),
        React.createElement(HorizonatlGridLine, { top: "66.6%" }),
        React.createElement(VerticalGridLine, { left: "33.3%" }),
        React.createElement(VerticalGridLine, { left: "66.6%" })));
};

export { ExtractPhotoTools, ExtractPhotoTools as default };
